



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Pie } from 'vue-chartjs/legacy';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(ChartDataLabels, ArcElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

export type DeclinedReason =
  | 'Preis'
  | 'Kein Bedarf/Interesse'
  | 'Zu komplex'
  | 'Nicht erreicht'
  | 'Nicht dringend'
  | 'Sonstiges';

interface DeclinedReasonCount {
  reason: DeclinedReason;
  count: number;
}

@Component({
  components: {
    Pie,
  },
})
export default class DeclinedReasonsPieChart extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: true }) subtitle!: string;
  @Prop({ type: Array, default: () => [] }) declinedReasons!: DeclinedReasonCount[];

  get hasData(): boolean {
    return this.declinedReasons && this.declinedReasons.length > 0;
  }

  get chartData() {
    // Sortiere die Daten nach Anzahl absteigend
    const sortedReasons = [...this.declinedReasons].sort((a, b) => b.count - a.count);

    return {
      labels: sortedReasons.map((item) => item.reason),
      datasets: [
        {
          backgroundColor: ['#28C76F', '#FF9F43', '#3A7BC7', '#71C7FF', '#A196FF', '#7f71fc'],
          data: sortedReasons.map((item) => item.count),
          borderWidth: 0,
        },
      ],
    };
  }

  get chartOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        datalabels: {
          formatter: (value: number, context: any) => {
            const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
            const percentage = (value / total) * 100;
            return (
              percentage.toLocaleString('de-DE', {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
              }) + ' %'
            );
          },
          color: '#fff',
          font: {
            weight: 'bold',
          },
          display: true,
          align: 'end',
          offset: 13,
        },
        legend: {
          position: 'top',
          align: 'start',
          labels: {
            usePointStyle: false,
            boxWidth: 15,
            padding: 8,
          },
        },
        tooltip: {
          backgroundColor: 'rgba(0,0,0,0.85)',
          boxPadding: 5,
          padding: 8,
          callbacks: {
            label: (context: any) => {
              const label = context.label || '';
              const value = context.raw || 0;
              const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
              const percentage = (value / total) * 100;
              return `${label}: ${value} (${percentage.toLocaleString('de-DE', {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
              })} %)`;
            },
          },
        },
      },
    };
  }
}
